var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3542 95.6875C8.45521 95.6875 5.9744 94.6562 3.91175 92.5935C1.8491 90.5309 0.816014 88.0483 0.8125 85.1458V11.3542C0.8125 8.45521 1.84558 5.9744 3.91175 3.91175C5.97792 1.8491 8.45872 0.816014 11.3542 0.8125H85.1458C88.0448 0.8125 90.5274 1.84558 92.5935 3.91175C94.6597 5.97792 95.691 8.45872 95.6875 11.3542V85.1458C95.6875 88.0448 94.6562 90.5274 92.5935 92.5935C90.5309 94.6597 88.0483 95.691 85.1458 95.6875H11.3542ZM11.3542 85.1458H85.1458V11.3542H11.3542V85.1458ZM16.625 74.6042H79.875L60.1094 48.25L44.2969 69.3333L32.4375 53.5208L16.625 74.6042Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.779e7ab7789aea8589b63a4795d44205.svg";
export { ForwardRef as ReactComponent };